import * as angular from 'angular';
import { ILoggerService } from '../../services';

export interface IDebugService {
    debug(title: string, content: any, style?: string): void;
    debugAndLog(title: string, content: any, style?: string): void;
}

export class DebugService implements IDebugService {
    static serviceId = 'debugService';

    static $inject = [
        'loggerService'
    ];

    constructor(
        private _loggerService: ILoggerService) {
    }

    debug(title: string, content: any, style?: string): void {
        if (!style) {
            style = 'font-weight: bold;';
        }
        console.log(`%c====${title}====`, style);
        console.log(content);
    }

    debugAndLog(title: string, content: any, style?: string): void {
        if (!style) {
            style = 'font-weight: bold;';
        }
        console.log(`%c====${title}====`, style);
        console.log(`%c${content}`, style);
        this._loggerService.log(title, false, content, 'debug', false);
    }
}